import type { RecommendationCardExtraProps } from "./recommendation-card-extra.type";

import { isRecommendationAssociatedWithManySections } from "@/entities/recommendation";
import RecommendationDeleteButton from "@/modules/recommendation/recommendation-delete-button";
import RecommendationDisableToggleButton from "@/modules/recommendation/recommendation-disable-toggle-button";
import RecommendationDisassociateButton from "@/modules/recommendation/recommendation-disassociate-button";

const RecommendationCardExtra = ({
  interventionId,
  observation,
  disabled,
}: RecommendationCardExtraProps) => {
  if (!observation?.id) return null;

  if (!observation.needs_recommendation) {
    return (
      <RecommendationDisableToggleButton
        observationId={observation.id}
        action="disable"
        isIconButton
        buttonProps={{ disabled }}
      />
    );
  }

  const recommendation = observation.recommendation;

  if (!recommendation) return null;

  if (isRecommendationAssociatedWithManySections(recommendation)) {
    return (
      <RecommendationDisassociateButton
        observation={observation}
        disabled={disabled}
      />
    );
  }

  return (
    <RecommendationDeleteButton
      interventionId={interventionId}
      recommendation={recommendation}
      disabled={disabled}
    />
  );
};

export default RecommendationCardExtra;
